import { css } from 'aphrodite/no-important';
import React from 'react';
import { Paragraph } from '@trainline/depot-web';
import { FormattedMessage } from 'react-intl';
import dayjs from 'dayjs';

import messages from '../../messages';

import { TrackingBoundaryIcon } from './TrackingBoundaryIcon';
import styles from './styles';

interface Props {
  displayTime: string;
  boundary: 'start' | 'end';
}

export const TrackingBoundary = ({ displayTime, boundary }: Props) => {
  const isStart = boundary === 'start';

  return (
    <div className={css([styles.trackItemGrid, styles.trackingBoundaryGrid])}>
      <TrackingBoundaryIcon boundary={boundary} />
      <div className={css(styles.trackItemTime)}>
        <Paragraph as="div" typeStyle="body">
          {dayjs(displayTime).format('HH:mm')}
        </Paragraph>
      </div>
      <div className={css(styles.trackItemInfo)}>
        <Paragraph as="span" typeStyle="body">
          {isStart ? (
            <FormattedMessage {...messages.trackingStarted} />
          ) : (
            <FormattedMessage {...messages.trackingStopped} />
          )}
        </Paragraph>
      </div>
    </div>
  );
};
